import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import {
  Box,
  Collapse,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  useTheme,
} from "@mui/material";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { myPermissions } from "../../../api/services";
import { icons } from "../../../assets";
import { handleChangePermissions } from "../../../redux/reducers/permissionSlice";
import ValidateAccess from "../../../routes/ValidateAccess";
import { StyledSideNav } from "../../../styles";
import { Permission } from "../../../utils/permissions";

const SideBar = () => {
  const theme = useTheme();
  const location = useLocation();
  const dispatch = useDispatch();
  const [open, setOpen] = useState<boolean>(false);
  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [openQuiz, setOpenQuiz] = useState(false);
  const [openconfig, setopenconfig] = useState(false);
  const [masterMenu, SetmasterMenu] = useState(false);
  const [Academics, SetAcademics] = useState(false);
  const [Userroles, setUserroles] = useState(false);

  const {
    data,
    isLoading,
    refetch: refetchPermissions,
  } = useQuery("userPermissions", myPermissions, {
    onSuccess: (data) => {
      const permissions = data?.data?.reduce((acc: any, item: any) => {
        acc[item.slug] = item.hasPermission;
        return acc;
      }, {});
      dispatch(handleChangePermissions({ ...permissions }));
    },
    onError: () => {
      localStorage.removeItem("access_token");
      toast.error("Failed to fetch user permissions");
    },
  });

  const Configuration = [
    {
      title: "Districts",
      path: "/master-data/districts",
      icon: icons.District,
    },
    {
      title: "Years",
      path: "/master-data/year",
      icon: icons.masterdata,
    },
    {
      title: "ITI Centre Type",
      path: "/master-data/iti-centre-type",
      icon: icons.iticentertype,
    },
    {
      title: "ITI Centres",
      path: "/master-data/iti-centres",
      icon: icons.ItiCenter,
    },
    {
      title: "Trade",
      path: "/master-data/trade",
      icon: icons.Trade,
    },
    {
      title: "Bundle-Types",
      path: "/master-data/bundle-types",
      icon: icons.bundletypes,
    },
    {
      title: "Roles",
      path: "/master-data/roles",
      icon: icons.roles,
    },
    {
      title: "Users",
      path: "/master-data/users",
      icon: icons.user,
    },
  ];

  const sideNavList = [
    {
      title: "Curriculums",
      path: "/curriculums",
      icon: icons.curriculums,
      permissionKey: Permission.manage_curriculum_permissions_view,
    },
    // {
    //   title: "Question Bank",
    //   path: "/question-bank",
    //   icon: icons.Questionbank,
    // },
    {
      title: "Questions",
      path: "/questions",
      icon: icons.Questionbank,
      permissionKey: Permission.manage_questions_permissions_view,
    },
    {
      title: "E-Books",
      path: "/e-books",
      icon: icons.ebooks,
      permissionKey: Permission.manage_ebook_permissions_view,
    },
    {
      title: "Study Materials",
      path: "/study-material",
      icon: icons.studyMaterial,
      permissionKey: Permission.manage_study_material_permissions_view,
    },
    {
      title: "Assignments",
      path: "/assignments",
      icon: icons.assignment,
      permissionKey: Permission.manage_assignment_permissions_view,
    },
    {
      title: "Resources",
      path: "/resources",
      icon: icons.resource,
      permissionKey: Permission.manage_resource_permissions_view,
    },
    // {
    //   title: "Students",
    //   path: "/Students",
    //   icon: icons.user,
    // },
    // {
    //   title: "E-Book Bundle",
    //   path: "/configuration",
    //   icon: icons.commonIcon,
    // },
    // {
    //   title: "Settings",
    //   path: "/configuration",
    //   icon: icons.commonIcon,
    // },
  ];

  const toggleCourses = [
    {
      title: "All Courses",
      path: "/courses/all-courses",
      icon: icons.user,
      permissionKey: Permission.manage_all_courses_permissions_view,
    },
    {
      title: "Courses Bundles",
      path: "/courses/course-bundles",
      icon: icons.Coursebundles,
      permissionKey: Permission.manage_course_bundles_permissions_view,
    },
  ];

  const toggleQuiz = [
    {
      title: "Quiz",
      path: "/app/quiz",
      icon: icons.Quiz,
      permissionKey: Permission.manage_quiz_permissions_view,
    },
    {
      title: "Exams",
      path: "/app/exams",
      icon: icons.Exams,
      permissionKey: Permission.manage_exam_permissions_view,
    },
    {
      title: "Grand Test",
      path: "/app/grand-test",
      icon: icons.Quiz,
      permissionKey: Permission.manage_grand_test_permissions_view,
    },
    {
      title: "Super Grand Test",
      path: "/app/super-grand-test",
      icon: icons.Exams,
      permissionKey: Permission.manage_super_grand_test_permissions_view,
    },
  ];

  const studentsMenu = [
    {
      title: "Waiting",
      path: "/students/waiting",
      icon: icons.user,
      permissionKey: Permission.manage_student_waiting_permissions_view,
    },
    {
      title: "Approved",
      path: "/students/approved",
      icon: icons.user,
      permissionKey: Permission.manage_student_approved_permissions_view,
    },
    {
      title: "Rejected",
      path: "/students/rejected",
      icon: icons.user,
      permissionKey: Permission.manage_student_rejected_permissions_view,
    },
  ];

  useEffect(() => {
    if (location.pathname.startsWith("/master-data")) {
      setOpen(true);
      setOpen1(false);
      setOpen2(false);
      setOpen3(false);
      setOpenQuiz(false);
    } else if (location.pathname.startsWith("/students")) {
      setOpen1(true);
      setOpen2(false);
      setOpen(false);
      setOpen3(false);
      setOpenQuiz(false);
    } else if (location.pathname.startsWith("/courses")) {
      setOpen1(false);
      setOpen2(true);
      setOpen(false);
      setOpen3(false);
      setOpenQuiz(false);
    } else if (location.pathname.startsWith("/app")) {
      setOpenQuiz(true);
      setOpen1(false);
      setOpen(false);
      setOpen2(false);
      setOpen3(false);
    } else if (location.pathname.startsWith("/students-corner")) {
      setOpen3(true);
      setOpen(false);
      setOpen1(false);
      setOpen2(false);
      setOpenQuiz(false);
    } else {
      setOpen(false);
      setOpen1(false);
      setOpen2(false);
      setOpenQuiz(false);
      setOpen3(false);
    }
  }, [location.pathname]);

  const StudentsCornerList = [
    {
      title: "Trade Time Table",
      path: "/students-corner/trade-time-table",
      icon: icons.Tradetimetable,
      permissionKey: Permission.manage_trade_time_table_permissions_view,
    },
    {
      title: "Examination Guideline",
      path: "/students-corner/examination-guideline",
      icon: icons.Examinationguidelines,
      permissionKey: Permission.manage_examination_guideline_permissions_view,
    },
    {
      title: "Live Session",
      path: "/students-corner/live-session",
      icon: icons.livesession,
      permissionKey: Permission.manage_live_session_permissions_view,
    },
    {
      title: "Discussion Forum ",
      path: "/students-corner/discussion-forum",
      icon: icons.Discussionfomr,
      permissionKey: Permission.manage_discussion_forum_permissions_view,
    },
  ];

  return (
    <StyledSideNav>
      <List sx={{ overflow: "auto", maxHeight: "90vh" }}>
        <ListItemButton
          selected={location.pathname.startsWith("/Student")}
          onClick={() => setOpen1(!open1)}
        >
          <ListItemIcon>
            <Box
              sx={{
                width: "100%",
                textAlign: "center",
              }}
            >
              <img src={icons.user} alt="" width={20} height={20} />
            </Box>
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography
                color={
                  location.pathname.startsWith("/students") ? "#F4347F" : "#000"
                }
                variant="h5"
              >
                Students
              </Typography>
            }
          />
          {open1 ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={open1} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {studentsMenu?.map((item: any, index: any) => (
              <Link
                key={index}
                to={item.path}
                style={{ textDecoration: "none" }}
              >
                <ValidateAccess accessKey={item.permissionKey}>
                  <ListItem disablePadding>
                    <ListItemButton
                      selected={location.pathname.startsWith(item.path)}
                      sx={{
                        "&.Mui-selected": {
                          opacity: "1",
                        },
                        "&.Mui-selected:hover": {},

                        paddingLeft: "30px",
                      }}
                    >
                      <ListItemIcon>
                        <Box
                          sx={{
                            width: "100%",
                            textAlign: "center",
                          }}
                        >
                          <img src={item.icon} alt="" width={20} height={20} />
                        </Box>
                      </ListItemIcon>
                      <ListItemText
                        primary={
                          <Typography
                            color={
                              location.pathname.startsWith(item.path)
                                ? "#F4347F"
                                : "#000"
                            }
                            variant="h5"
                          >
                            {item?.title}
                          </Typography>
                        }
                      />
                    </ListItemButton>
                    <Box
                      sx={{
                        height: "45px",
                        width: "5px",
                        borderRadius: "10px 0 0 10px",
                        bgcolor: location.pathname.startsWith(item?.path)
                          ? theme.palette.primary.main
                          : "#fff",
                      }}
                    />
                  </ListItem>
                </ValidateAccess>
              </Link>
            ))}
          </List>
        </Collapse>

        {sideNavList?.slice(0, 1)?.map((item: any, index: any) => (
          <Link key={index} to={item.path} style={{ textDecoration: "none" }}>
            <ValidateAccess accessKey={item.permissionKey}>
              <ListItem disablePadding>
                <ListItemButton
                  selected={location.pathname.startsWith(item.path)}
                  sx={{
                    "&.Mui-selected": {
                      opacity: "1",
                    },
                    "&.Mui-selected:hover": {},
                  }}
                >
                  <ListItemIcon>
                    <Box
                      sx={{
                        width: "100%",
                        textAlign: "center",
                      }}
                    >
                      <img src={item.icon} alt="" width={20} height={20} />
                    </Box>
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography
                        color={
                          location.pathname.startsWith(item.path)
                            ? "#F4347F"
                            : "#000"
                        }
                        variant="h5"
                      >
                        {item?.title}
                      </Typography>
                    }
                  />
                </ListItemButton>
                <Box
                  sx={{
                    height: "45px",
                    width: "5px",
                    borderRadius: "10px 0 0 10px",
                    bgcolor: location.pathname.startsWith(item?.path)
                      ? theme.palette.primary.main
                      : "#fff",
                  }}
                />
              </ListItem>
            </ValidateAccess>
          </Link>
        ))}

        <ListItemButton
          selected={location.pathname.startsWith("/courses")}
          onClick={() => setOpen2(!open2)}
        >
          <ListItemIcon>
            <Box sx={{ width: "100%", textAlign: "center" }}>
              <img src={icons.Courses} alt="" width={20} height={20} />
            </Box>
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography
                color={
                  location.pathname.startsWith("/courses") ? "#F4347F" : "#000"
                }
                variant="h5"
              >
                Courses
              </Typography>
            }
          />
          {open2 ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>

        <Collapse in={open2} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {toggleCourses?.map((item: any, index: any) => (
              <Link
                key={index}
                to={item.path}
                style={{ textDecoration: "none" }}
              >
                <ValidateAccess accessKey={item.permissionKey}>
                  <ListItem disablePadding>
                    <ListItemButton
                      selected={location.pathname.startsWith(item.path)}
                      sx={{
                        "&.Mui-selected": {
                          opacity: "1",
                        },
                        "&.Mui-selected:hover": {},

                        paddingLeft: "30px",
                      }}
                    >
                      <ListItemIcon>
                        <Box
                          sx={{
                            width: "100%",
                            textAlign: "center",
                          }}
                        >
                          <img src={item.icon} alt="" width={20} height={20} />
                        </Box>
                      </ListItemIcon>
                      <ListItemText
                        primary={
                          <Typography
                            color={
                              location.pathname.startsWith(item.path)
                                ? "#F4347F"
                                : "#000"
                            }
                            variant="h5"
                          >
                            {item?.title}
                          </Typography>
                        }
                      />
                    </ListItemButton>
                    <Box
                      sx={{
                        height: "45px",
                        width: "5px",
                        borderRadius: "10px 0 0 10px",
                        bgcolor: location.pathname.startsWith(item?.path)
                          ? theme.palette.primary.main
                          : "#fff",
                      }}
                    />
                  </ListItem>
                </ValidateAccess>
              </Link>
            ))}
          </List>
        </Collapse>

        {sideNavList?.slice(1, 2)?.map((item: any, index: any) => (
          <Link key={index} to={item.path} style={{ textDecoration: "none" }}>
            <ValidateAccess accessKey={item.permissionKey}>
              <ListItem disablePadding>
                <ListItemButton
                  selected={location.pathname.startsWith(item.path)}
                  sx={{
                    "&.Mui-selected": {
                      opacity: "1",
                    },
                    "&.Mui-selected:hover": {},
                  }}
                >
                  <ListItemIcon>
                    <Box
                      sx={{
                        width: "100%",
                        textAlign: "center",
                      }}
                    >
                      <img src={item.icon} alt="" width={20} height={20} />
                    </Box>
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography
                        color={
                          location.pathname.startsWith(item.path)
                            ? "#F4347F"
                            : "#000"
                        }
                        variant="h5"
                      >
                        {item?.title}
                      </Typography>
                    }
                  />
                </ListItemButton>
                <Box
                  sx={{
                    height: "45px",
                    width: "5px",
                    borderRadius: "10px 0 0 10px",
                    bgcolor: location.pathname.startsWith(item?.path)
                      ? theme.palette.primary.main
                      : "#fff",
                  }}
                />
              </ListItem>
            </ValidateAccess>
          </Link>
        ))}

        <ListItemButton
          selected={location.pathname.startsWith("/quiz")}
          onClick={() => setOpenQuiz(!openQuiz)}
        >
          <ListItemIcon>
            <Box
              sx={{
                width: "100%",
                textAlign: "center",
              }}
            >
              <img src={icons.Exams} alt="" width={20} height={20} />
            </Box>
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography
                color={
                  location.pathname.startsWith("/app") ? "#F4347F" : "#000"
                }
                variant="h5"
              >
                Tests
              </Typography>
            }
          />
          {openQuiz ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>

        <Collapse in={openQuiz} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {toggleQuiz?.map((item: any, index: any) => (
              <Link
                key={index}
                to={item.path}
                style={{ textDecoration: "none" }}
              >
                <ValidateAccess accessKey={item.permissionKey}>
                  <ListItem disablePadding>
                    <ListItemButton
                      selected={location.pathname.startsWith(item.path)}
                      sx={{
                        "&.Mui-selected": {
                          opacity: "1",
                        },
                        "&.Mui-selected:hover": {},

                        paddingLeft: "30px",
                      }}
                    >
                      <ListItemIcon>
                        <Box
                          sx={{
                            width: "100%",
                            textAlign: "center",
                          }}
                        >
                          <img src={item.icon} alt="" width={20} height={20} />
                        </Box>
                      </ListItemIcon>
                      <ListItemText
                        primary={
                          <Typography
                            color={
                              location.pathname.startsWith(item.path)
                                ? "#F4347F"
                                : "#000"
                            }
                            variant="h5"
                          >
                            {item?.title}
                          </Typography>
                        }
                      />
                    </ListItemButton>
                    <Box
                      sx={{
                        height: "45px",
                        width: "5px",
                        borderRadius: "10px 0 0 10px",
                        bgcolor: location.pathname.startsWith(item?.path)
                          ? theme.palette.primary.main
                          : "#fff",
                      }}
                    />
                  </ListItem>
                </ValidateAccess>
              </Link>
            ))}
          </List>
        </Collapse>
        {sideNavList?.slice(2, 6)?.map((item: any, index: any) => (
          <Link key={index} to={item.path} style={{ textDecoration: "none" }}>
            <ValidateAccess accessKey={item.permissionKey}>
              <ListItem disablePadding>
                <ListItemButton
                  selected={location.pathname.startsWith(item.path)}
                  sx={{
                    "&.Mui-selected": {
                      opacity: "1",
                    },
                    "&.Mui-selected:hover": {},
                  }}
                >
                  <ListItemIcon>
                    <Box
                      sx={{
                        width: "100%",
                        textAlign: "center",
                      }}
                    >
                      <img src={item.icon} alt="" width={20} height={20} />
                    </Box>
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography
                        color={
                          location.pathname.startsWith(item.path)
                            ? "#F4347F"
                            : "#000"
                        }
                        variant="h5"
                      >
                        {item?.title}
                      </Typography>
                    }
                  />
                </ListItemButton>
                <Box
                  sx={{
                    height: "45px",
                    width: "5px",
                    borderRadius: "10px 0 0 10px",
                    bgcolor: location.pathname.startsWith(item?.path)
                      ? theme.palette.primary.main
                      : "#fff",
                  }}
                />
              </ListItem>
            </ValidateAccess>
          </Link>
        ))}

        <ListItemButton
          selected={location.pathname.startsWith("/students-corner")}
          onClick={() => setOpen3(!open3)}
        >
          <ListItemIcon>
            <Box
              sx={{
                width: "100%",
                textAlign: "center",
              }}
            >
              <img src={icons.studentscorner} alt="" width={20} height={20} />
            </Box>
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography
                color={
                  location.pathname.startsWith("/students-corner")
                    ? "#F4347F"
                    : "#000"
                }
                variant="h5"
              >
                Students Corner
              </Typography>
            }
          />
          {open3 ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>

        {/* <ListItemButton
          selected={location.pathname.startsWith("/students-corner")}
          onClick={() => setOpen3(!open3)}
        >
          <ListItemIcon>
            <Box
              sx={{
                width: "100%",
                textAlign: "center",
              }}
            >
              <img src={icons.studentscorner} alt="" width={20} height={20} />
            </Box>
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography
                color={
                  location.pathname.startsWith("/students-corner")
                    ? "#F4347F"
                    : "#000"
                }
                variant="h5"
              >
                Students Corner
              </Typography>
            }
          />
          {open3 ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton> */}
        <Collapse in={open3} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {StudentsCornerList?.map((item: any, index: any) => (
              <Link
                key={index}
                to={item.path}
                style={{ textDecoration: "none" }}
              >
                <ValidateAccess accessKey={item.permissionKey}>
                  <ListItem disablePadding>
                    <ListItemButton
                      selected={location.pathname.startsWith(item.path)}
                      sx={{
                        "&.Mui-selected": {
                          opacity: "1",
                        },
                        "&.Mui-selected:hover": {},

                        paddingLeft: "30px",
                      }}
                    >
                      <ListItemIcon>
                        <img src={item.icon} alt="" width={20} height={20} />
                        <Box
                          sx={{
                            width: "100%",
                            textAlign: "center",
                          }}
                        ></Box>
                      </ListItemIcon>
                      <ListItemText
                        primary={
                          <Typography
                            color={
                              location.pathname.startsWith(item.path)
                                ? "#F4347F"
                                : "#000"
                            }
                            variant="h5"
                          >
                            {item?.title}
                          </Typography>
                        }
                      />
                    </ListItemButton>
                    <Box
                      sx={{
                        height: "45px",
                        width: "5px",
                        borderRadius: "10px 0 0 10px",
                        bgcolor: location.pathname.startsWith(item?.path)
                          ? theme.palette.primary.main
                          : "#fff",
                      }}
                    />
                  </ListItem>
                </ValidateAccess>
              </Link>
            ))}
          </List>
        </Collapse>
      </List>
    </StyledSideNav>
  );
};

export default SideBar;
